import React, { FC } from 'react';
import { useStorage } from '~Components/Storage';
import SelectList from '~ComponentsImproved/SelectList';
import { useDispatch, useI18n, useLogger, useSelector } from '~Hooks';
import * as actions from '~actions';

interface Props {
  isKDSOnboarding?: boolean;
}

/**
 * Station picker, also used standalone in the "assign station" modal
 * (EventedKitchenDisplay/Components/SelectStation.tsx).
 */
export const StationSettings: FC<Props> = ({ isKDSOnboarding }) => {
  const logger = useLogger('settings-v2');
  const [storage, updateStorage, storageLoading] = useStorage();
  const stations = useSelector((state) => state.stations ?? []);
  const dispatch = useDispatch();
  const { i18n } = useI18n();

  const update = (stationId: string) => {
    // Still setting station in state becuase old KDS uses it
    dispatch(actions.setStation(stationId));
    updateStorage({ selectedKDSStation: stationId });

    const selected = stations.find((station) => station.id === stationId);

    logger.info('Updating Settings (change station)', {
      fields: { selectedStationId: stationId, selectedStationName: selected?.name },
    });

    dispatch(actions.addToast(i18n('TOAST.Station.Updated'), true));
  };

  if (storageLoading) {
    return null;
  }

  return (
    <SelectList
      label={i18n('Settings.KDS.Station')}
      list={[
        {
          id: 'NONE',
          name: !isKDSOnboarding
            ? `${i18n('Settings.StationNone')} ${i18n('Settings.StationDontAssign')}`
            : i18n('Settings.Station.PressToSelect'),
        },
        ...stations.map((station) => ({
          id: station.id,
          name: station.name,
        })),
      ]}
      selectedId={storage.selectedKDSStation ?? 'NONE'}
      onSelect={update}
    />
  );
};
